import { IntlShape } from 'react-intl'

import { lgbtMessages } from 'common/constants'
import { Gender } from 'common-constants/api6.types'
import { GQLGender } from 'generated-graphql/graphql'

export const getLgbtModifiedLexemes = (
  gender: Gender | GQLGender,
  intl: IntlShape
) => {
  return [
    {
      name: intl.formatMessage(lgbtMessages.searchAll),
      value: Gender.Any,
    },
    {
      name: createLgbtModifiedLexeme(gender, Gender.Male, intl),
      value: Gender.Male,
    },
    {
      name: createLgbtModifiedLexeme(gender, Gender.Female, intl),
      value: Gender.Female,
    },
  ]
}

export const createLgbtModifiedLexeme = (
  authUserGender: Gender | GQLGender,
  lookForGender: Gender | GQLGender | string,
  intl: IntlShape,
  isGuyInsteadMan: boolean = false
) => {
  switch (authUserGender) {
    case Gender.Male:
      switch (lookForGender) {
        case Gender.Male:
          return intl.formatMessage(lgbtMessages.genderMFriend)
        case Gender.Female:
          return intl.formatMessage(lgbtMessages.genderFGirl)
      }

    case Gender.Female:
      switch (lookForGender) {
        case Gender.Male:
          if (isGuyInsteadMan) {
            return intl.formatMessage(lgbtMessages.genderMGuy)
          }
          return intl.formatMessage(lgbtMessages.genderMMan)
        case Gender.Female:
          return intl.formatMessage(lgbtMessages.genderFFriend)
      }
  }

  return ''
}
